<template lang="pug">
  validation-observer.analise(ref='validation' tag='div', v-if="dadosCadastros")
      el-card(shadow='hover').card-collapse
        app-header-dados-processo(
          :processo="processo",
          :isCCR="isCCR",
          :dadosCadastros="dadosCadastros",
          :numeroTituloDominial="numeroTituloDominial"
          :numeroProcessoFisico="numeroProcessoFisico"
          :dataEmissaoTituloDominial="dataEmissaoTituloDominial"
        )
      div
        el-card(shadow="hover").card-collapse
          app-despachos(
            v-if=dadosCadastros
            :idProcesso="idProcesso",
            :data="dadosCadastros.setores",
            @getDownload="getDownload",
            :tituloMinuta="dadosCadastros.despacho.processo.tipo.codigo === 'CERTIDAO_TITULO' ? 'Minuta da certidão' : 'Minuta do título'"
          )
          app-dados-cadastro(
            v-if="(documentosValidar && !isRetornarOuArquivar && showValidacaoDocumentos)"
            :dadosCadastros="responseAnalise.dadosCadastros",
            @setValidacaoDocumentos="setValidacaoDocumentos",
            @downloadDocumentoCadastro="downloadDocumentoCadastro"
            @setDocumentosValidar="setDocumentosValidar"
          )
      el-col(:span="6", style="margin: 15px")
        app-label(label="Processo SEI (Sistema Eletrônico de Informações):", :required="true")
        validation-provider(rules="required", v-slot="{ errors }")
          el-input.input(
            name="N° SEI"
            v-model="numeroSei",
            :class="{'erro' : errors.length && !dadosCadastros.despacho.numeroSei}"
          )
            el-button(
              style="color: #009f61;"
              slot="append",
              icon="el-icon-plus",
              @click="addNumeroSei()",
            )
          div(style="margin-top: 10px;")
            el-tag(
              v-if="dadosCadastros.despacho.numeroSei"
              closable,
              type="info",
              size="medium",
              style="margin: 5px"
              @close="removeNumeroSei()"
            ) {{ dadosCadastros.despacho.numeroSei }}
          span.help.erro(v-if="errors.length && !dadosCadastros.despacho.numeroSei") {{ errors[0] }}
      el-card(shadow="hover",v-if="dadosCadastros").card-collapse
        div(v-if="showDespachoAndAnexo()")
          validation-provider(rules="required", v-slot="{ errors }")
            .flex-despacho
              p.label {{ formatterTipoDespacho }}
                span.required &nbsp * &nbsp

            app-editor-texto.input(
              @onTextChange="onTextChange",
              v-model="dadosCadastros.despacho.textoDespacho",
              :class="{'erro' : errors.length}"
              ref="editorTexto"
            )
            span.help.erro {{ errors[0] }}
          app-anexo(
            :id="'upload-anexo-despacho'",
            v-if="anexos && dadosCadastros.despacho",
            @uploadFile="uploadFile",
            :files="anexos",
            @removeFile="removeFile"
            @downloadDocumentoCadastro="downloadDocumentoCadastro",
            :tipoExibir="'ANEXO_ANALISE'"
          )
</template>
<script>
import utils from '@/utils/utils'
import FileSaver from 'file-saver'
import AppDespachos from '@/components/AppDespachos'
import AppDadosCadastro from '@/components/AppDadosCadastro.vue'
import AppActionButton from '@/components/AppActionButton.vue'
import AppEditorTexto from '@/components/AppEditorTexto'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppAnexo from '@/components/AppAnexo'
import AppRadiosTramitacao from '@/components/AppRadiosTramitacao'
import axios from '@/utils/api'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppModalSelecionarModeloNotificacao from './components/AppModalSelecionarModeloNotificacao'
import { mapActions } from 'vuex'
import AppDisplay from '@/components/AppDisplay'
import AppDivider from '@/components/AppDivider'
import AppDownloadAnexo from '@/components/AppDownloadAnexo'
import AppDadosGeraisOs from '@/components/AppDadosGeraisOs'
import AppLabel from '@/components/AppLabel'
import AppDocumentos from '../central/components/cadastro/AppDocumentos'
import _ from 'lodash'
import statusProcesso from '@/utils/status'
import AppHeaderDadosProcesso from '@/components/AppHeaderDadosProcesso.vue'
import AppVisualizarConversa from '@/screens/central/components/centralMensagens/AppVisualizarConversa.vue'
const regrasAnalise = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

const {
  cadastro
} = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  components: {
    AppDespachos,
    AppDadosCadastro,
    AppEditorTexto,
    AppButtonsCadastro,
    AppAnexo,
    AppActionButton,
    AppRadiosTramitacao,
    AppModalSelecionarModeloNotificacao,
    AppDisplay,
    AppDivider,
    AppDownloadAnexo,
    AppDadosGeraisOs,
    AppLabel,
    AppDocumentos,
    AppHeaderDadosProcesso,
    AppVisualizarConversa
  },

  mixins: [AppNotificacao],

  props: {
    processo: {
      required: true
    },
    responseAnalise: {
      required: true
    },
    idProcesso: {
      required: true
    },
    acaoCaixa: {
      type: String,
      default: null
    },
    regras: {
      required: true
    }
  },

  computed: {
    isRetornarOuArquivar () {
      if (this.processo.status === statusProcesso.EM_ARQUIVAMENTO) {
        return false
      }
      if (this.dadosCadastros?.isDocumentosGeoRevisao) {
        return this?.dadosCadastros?.despacho?.acao
          ? this?.dadosCadastros?.despacho?.acao.includes('ARQUIVA')
          : false
      }
      return this?.dadosCadastros?.despacho?.acao
        ? this?.dadosCadastros?.despacho?.acao.includes('RETORNO') ||
              this?.dadosCadastros?.despacho?.acao.includes('ARQUIVA') ||
              this?.dadosCadastros?.despacho?.acao.includes('CAF_REVISAO')
        : false
    },

    formatterTipoDespacho () {
      return 'Despacho'
    },

    isAnaliseArquivamento () {
      return this.dadosCadastros?.showAnaliseArquivamento
    },

    isDecisaoFinal () {
      return this.dadosCadastros?.showDecisaoFinal
    },

    showButtonsTramitacao () {
      return (
        (!cadastro.statusBotoesDecisao.status.includes(this.processo?.status) ||
          cadastro.statusBotoesDecisao.despacho.includes(
            this.dadosCadastros?.despacho?.tipo
          ))
      )
    },

    isOnerosoNaoOneroso () {
      return ['ONEROSO', 'NAO_ONEROSO', 'NAO_ONEROSO_FISICO', 'ONEROSO_FISICO'].includes(this.processo.tipo.codigo)
    }
  },

  data () {
    return {
      dataDespachos: [],
      dadosCadastros: undefined,
      anexos: [],
      radios: [],
      acoesRadio: [],
      showModal: false,
      isFinalizada: false,
      numeroProcesso: '',
      isDecisao: false, // variavel utilizado para selecionar a decisão de despacho selecionada e enviar para o componente que exibe os radios
      documentosValidar: true,
      decisao: {},
      funcao: [],
      hasAnexoDocumento: false,
      componenteAnexoDocumento: null,
      hasClickFinalizar: true,
      dadosCadastro: [],
      numeroTituloDominial: null,
      numeroProcessoFisico: null,
      dataEmissaoTituloDominial: null,
      isCCR: false,
      isUltimoPasso: true,
      showButtonProximo: false,
      extensoes: ['pdf', 'jpeg', 'png', 'docx', 'xls', 'xlsx', 'ods', 'zip', 'rar', 'jpg', 'doc'],
      showValidacaoDocumentos: false,
      isBa: process.env.ESTADO === 'ba',
      user: null,
      isGit: false,
      numeroSei: ''
    }
  },

  async created () {
    this.user = await this.getUsuario()
    this.isGit = this.user.perfilSelecionado.codigo.includes('GIT')
    await this.montarTela()
    this.showValidacaoDocumentos = regrasAnalise.showValidacaoDocumentos.perfis.includes(this.user.perfilSelecionado.codigo) || this.dadosCadastros.showValidacaoVerificacao
  },

  methods: {

    ...mapActions({
      tarefa: 'processo/tarefa',
      getSubcaixaAtual: 'processo/subcaixaAtual',
      getProcesso: 'processos/getProcessoByProtocolo',
      findTiposDocumentoTipoProcesso:
          'tipoDocumento/findTiposDocumentoTipoProcesso',
      getUsuario: 'auth/getUsuario',
      statusDoProcesso: 'processo/statusProcessoFila',
      iniciaAnaliseProcesso: 'processo/iniciaAnalise',
      finalizarDespacho: 'despacho/finalizar'
    }),

    formatDate (value) {
      return value ? utils.formatDate(value) : '-'
    },

    async proximo () {
      await this.salvar()
    },

    showDespachoAndAnexo () {
      switch (this.processo.status) {
        case 'ENVIADO_PARA_PUBLICACAO':
        case 'AGUARDANDO_PUBLICACAO':
        case 'CADASTRANDO_DADOS_CUSTA':
          if (this.isAp && this.isRetornarOuArquivar) {
            return true
          }
          break
        case 'EM_PUBLICACAO_PORTARIA':
        case 'AGUARDANDO_TERMO_CONTRATO':
          return false
        default:
          return true
      }
    },

    mensagemAnaliseBemSucedida (setor, status) {
      if (status === 'ARQUIVADO') {
        return `Processo arquivado com sucesso`
      }
      if (!status && setor === 'GABINETE' && this.isMa) {
        return 'Análise finalizada.'
      }
      if (setor && setor !== '' && setor !== 'SISTEMA') {
        if (setor.includes('_')) {
          setor = setor.replace(/_/g, '/')
        }
        return `Análise finalizada. Processo enviado para o setor ${setor}.`
      } else {
        return 'Análise finalizada.'
      }
    },

    changeRadio (value) {
      this.dadosCadastros.despacho.acao = value.acao
      if (value.usuario) {
        this.dadosCadastros.despacho.processo.usuarioEncaminhar = {
          id: value.usuario
        }
      }
    },

    async removeFile (documento) {
      this.confirmBox(
        this.$messages.DOCUMENTO_REMOVE_CONFIRM,
        this.$messages.TITULO_WARNING,
        () => {
          this.deleteAnexo(documento)
        },
        () => {}
      )
    },

    deleteAnexo (documento) {
      if (documento.id) {
        const index = this.anexos.indexOf(
          this.anexos.find(a => a.id === documento.id)
        )
        this.anexos.splice(index, 1)
      } else {
        const index = this.anexos.indexOf(
          this.anexos.find(a => a.key === documento.key)
        )
        this.anexos.splice(index, 1)
      }
    },

    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    },

    downloadDocumentoCadastro (documento) {
      this.getDownload(documento)
    },
    cancelar () {
      var rota = ''
      switch (this.acaoCaixa) {
        case 'ANALISE':
          rota = 'EM_ANALISE'
          break
        case 'VALIDAR':
          rota = 'VALIDACAO'
          break
        case 'ANALISE_SEM_TRAMITACAO':
          rota = 'CAIXA_ENTRADA'
          break
        case 'UPLOAD_TERMO_RECEBIMENTO_CONTRATO':
          rota = 'DOCUMENTOS'
          break
        case 'ELABORAR_EDITAL':
          rota = 'EDITAL_PUBLICACAO'
          break
        case 'ACUSAR_ENTREGA' :
          rota = 'TITULOS_PARA_ENTREGA'
          break
        default:
          rota = 'EM_ANALISE'
      }
      this.$router.push({
        name: rota
      })
    },

    setValidacaoDocumentos (dadosCadastor) {
      let i = 0
      this.dadosCadastros.dadosCadastros.map((dados, index) => {
        if (dados.tipo === dadosCadastor.tipo) {
          i = index
        }
      })
      this.dadosCadastros.dadosCadastros[i] = dadosCadastor
    },

    onTextChange (text) {
      this.dadosCadastros.despacho.textoDespacho = text
    },

    async salvar () {
      try {
        await this.atualizaDocumentos()
        await axios({
          method: 'post',
          data: this.dadosCadastros.despacho,
          url: 'despacho/salvar',
          error: true
        })
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          'Análise salva!'
        )
      } catch (error) {
        const messagemDeErro = Array.isArray(error.erros)
          ? error.erros.join(';')
          : 'Houve um erro ao salvar a análise.'
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          messagemDeErro
        )
      }
    },
    mensagemFinalizacao () {
      return this.$messages.FINALIZAR_ANALISE
    },
    async finalizar () {
      if (!this.hasClickFinalizar) {
        return
      }
      const valido = await this.$refs.validation.validate()
      if (!valido) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERROS_ANALISE
        )
        return
      }
      try {
        this.hasClickFinalizar = false
        await this.atualizaDocumentos()

        if (!this.showDespachoAndAnexo()) {
          this.dadosCadastros.despacho.textoDespacho = ''
        }
        await this.finalizarDespacho(this.dadosCadastros.despacho)
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS
        )
        this.hasClickFinalizar = true
        this.active++
      } catch (error) {
        console.error(error)
      }
    },

    async atualizaDocumentos () {
      this.dadosCadastros.despacho.documentos = _.cloneDeep(this.anexos)
      if (this.isRetornarOuArquivar) {
        return
      }
      await this.dadosCadastros.dadosCadastros.map(dados => {
        if (dados.tipo === 'tabelaComCheck') {
          if (dados && dados.data) {
            dados.data.map(documento => {
              documento.id = null
              this.dadosCadastros.despacho.documentos.push(documento)
            })
          }
        }
      })
    },

    uploadFile (file) {
      this.anexos.push({
        key: file.response,
        nome: file.name,
        tipo: {
          id: 51,
          codigo: 'ANEXO_ANALISE'
        }
      })
    },

    setDocumentosValidar (validar) {
      this.documentosValidar = validar
    },

    async montarTela () {
      let acaoSelecionada = null
      let usuarioEncaminhar = null
      if (this.dadosCadastros?.despacho?.processo?.usuarioEncaminhar) {
        usuarioEncaminhar = _.cloneDeep(
          this.dadosCadastros.despacho.processo.usuarioEncaminhar
        )
      }
      if (this.dadosCadastros && this.dadosCadastros.despacho.acao) {
        acaoSelecionada = this.dadosCadastros.despacho.acao
      } else {
        acaoSelecionada = this.responseAnalise.despacho.acao
      }
      this.radios = await this.tarefa({ processo: this.idProcesso })

      try {
        this.numeroProcesso = this.processo.numeroProcesso
        this.acoesRadio = this.radios.acoes
        this.anexos = this.responseAnalise.despacho.anexos
        this.dadosCadastros = this.responseAnalise
        this.dadosCadastros.despacho.documentos = []
        if (usuarioEncaminhar !== null) {
          this.dadosCadastros.despacho.processo.usuarioEncaminhar = usuarioEncaminhar
        }
        this.dadosCadastros.despacho.tarefaId = this.radios.id
        this.dataDespachos = this.responseAnalise.setores
        this.dadosCadastros.despacho.acao = acaoSelecionada
        if (this.regras.decisoes) {
          this.decisao = this.regras.decisoes
        }
        if (!this.showButtonsTramitacao) {
          this.dadosCadastros.despacho.acao = this.acoesRadio[0].valor
        }
      } catch (error) {
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          error.message,
          8000
        )
        this.cancelar()
      }
    },

    setActivePai (valor) {
      this.$emit('setActive', valor)
    },

    voltar () {
      this.$router.back()
    },
    addNumeroSei () {
      if (!this.dadosCadastros.despacho.numeroSei) {
        this.dadosCadastros.despacho.numeroSei = ''
      }
      if (this.dadosCadastros.despacho.numeroSei.includes(this.numeroSei)) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Este N° SEI já foi adicionado')
      } else {
        this.dadosCadastros.despacho.numeroSei = this.numeroSei
        this.numeroSei = ''
      }
    },
    removeNumeroSei () {
      this.dadosCadastros.despacho.numeroSei = ''
    }

  }
}
</script>
  <style lang="scss">

  .el-collapse-item__header {
    color: rgb(112, 112, 112);
    font-size: 16px;
  }

  .padding {
    padding: 5px;
  }

  .required {
    color: firebrick;
  }

  .flex-despacho {
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;
    align-items: center;
  }

  .container-buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .label {
    font-weight: bold;
  }

  .analise {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .card-collapse {
    border-radius: 10px;
    margin: 10px 0;
  }

  .btn-actions {
    display: flex;
    justify-content: space-between;
  }

  .flex {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
  }

  .flex .el-button span {
    display: flex;
  }

  .right {
    float: right;
  }

  .extra-margin-top-bottom {
    margin-top: 30px;
    margin-bottom: 30px;
  }

  .margin-medium-top {
    margin-top: 20px;
  }

  .campo {
    margin-top: 2%;
  }

  .button {
    border: none;
    background: none;
    padding: 0;
  }

  .button-modal-label {
    font-weight: bold;
    color: #009c66 !important;
  }

  .button-comIcone span {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .marginBotton {
    margin-bottom: 20px;
  }

  .full-width {
    width: 100%;
  }

  @media (max-width: 780px) {
    .buttonValidarProcesso {
      flex-direction: column;
    }

    .btn {
      margin-bottom: 10px;
    }
  }
  </style>



// WEBPACK FOOTER //
// src/screens/analise/AnalisarValidarProcessoBa.vue